import React, { Component } from "react";
import Firebase from "firebase";
import Connector from "../../data/Connector";
import EventEmitter from "../../helper/Emitter";
import HelperClients from "../../helper/Clients";
import HelperBusiness from "../../helper/Business";
import ListEmpty from "../List/empty";
import InputDate from "../../components/Form/input-date";
import Textarea from "../../components/Form/textarea";
import Select from "../../components/Form/select";
import ModalClients from "../../components/Modals/clients";
import Moment from "moment";
import "moment/locale/es";
import { withTranslation } from "react-i18next";
import lang from "i18next";

class Chat extends Component {
  constructor(props) {
    super(props);
    this.state = {
      chats: global.chats,
      chatsGroup: global.chatsGroup,
      chatsUnread: [],
      chatsUnreadSingle: [],
      clients: global.clients,
      staff: global.userStaff,
      show: false,
      hidden: "hidden",
      mode: "list",
      name: "Client",
      search: "",
      chat: "",
      messages: [],
      text: "",
      client: "",
      images: [],
      // Form
      available: [],
      selected: [],
      selectedInit: [],
      savailable: [],
      sselected: [],
      sselectedInit: [],
      value: "",
      error: ["", ""],
      margin: 0,
      date: Moment().format("YYYY-MM-DD"),
      min: "00",
      sec: "00",
      mid: "",
      hiddenSchedule: "hidden",
      showModalClients: false,
      showModalSchedule: false,
    };
  }

  componentDidMount() {
    EventEmitter.subscribe("clientsLoaded", (event) => this.configureData());
    EventEmitter.subscribe("chatsLoaded", (event) => this.configureData());
    EventEmitter.subscribe("chatsGroupLoaded", (event) => this.configureData());
    EventEmitter.subscribe("locationSet", (event) => this.configureData());
    this.configureData();
  }

  configureData() {
    var tmp = [];
    var tmp2 = [];
    var tmp3 = [];
    var tmp4 = [];
    var tmp41 = [];
    var tmp5 = [];
    var tmp51 = [];

    var list = [];
    var list2 = [];
    if (global.loc === "") {
      for (var cl of global.clients) {
        list.push(cl.id);
      }
      for (var cl2 of global.clientsInactive) {
        list.push(cl2.id);
      }
      for (var st of global.userStaff) {
        list2.push(st.id);
      }
    } else {
      for (var loc of global.locations) {
        if (loc.id === global.loc && loc.data.clients !== undefined) {
          list = loc.data.clients;
        }
        if (loc.id === global.loc && loc.data.staff !== undefined) {
          list2 = loc.data.staff;
        }
      }
    }

    for (var item5 of global.chats) {
      var isImportant = false;
      var trainerTime5 = item5.data.timeTrainer !== undefined && !isNaN(parseInt(item5.data.timeTrainer)) ? parseInt(item5.data.timeTrainer) : 0;
      if (trainerTime5 > 9999999999) trainerTime5 = Math.floor(trainerTime5 / 1000);
      if (item5.data.dateTrainer && Moment(item5.data.dateTrainer, "DD/MM/YYYY HH:mm:ss").isValid()) {
        var dtTrain5 = parseInt(Moment(item5.data.dateTrainer, "DD/MM/YYYY HH:mm:ss").format("X"));
        if (!isNaN(dtTrain5) && dtTrain5 > 0) {
          trainerTime5 = Math.max(trainerTime5, dtTrain5);
        }
      }
      for (var msg5 of item5.messages) {
        msg5.date = Moment(msg5.data.date, "DD/MM/YYYY HH:mm:ss");
        if (msg5.data.timestamp !== undefined) {
          var msgTs5 = parseInt(msg5.data.timestamp);
          if (msgTs5 > 9999999999) msgTs5 = Math.floor(msgTs5 / 1000);
          msg5.date = Moment(msgTs5, "X");
        }
        var msgTime5 = parseInt(msg5.date.format("X"));
        if (
          msgTime5 > trainerTime5 &&
          msg5.data.sender !== global.uidUser
        ) {
          isImportant = true;
        }
      }
      if (isImportant) {
        tmp51.push(item5.id);
        if (this.state.search === "") {
          tmp5.push(item5.id);
        } else if (
          this.state.search !== "" &&
          item5.data.nameClient
            .toLowerCase()
            .indexOf(this?.state?.search?.toLowerCase()) !== -1
        ) {
          tmp5.push(item5.id);
        }
      }
    }

    for (var item of global.clients) {
      // Code change by Differenz (23-Feb-2026)
      if (item?.data?.uid !== "" && list?.indexOf(item?.id) !== -1) {
        tmp2.push(item);
        if (tmp51?.indexOf(global?.uidUser + item?.data?.uid) === -1) {
          if (this.state.search === "") {
            tmp.push(item);
          } else if (
            this.state.search !== "" &&
            item.data.name
              .toLowerCase()
              .indexOf(this?.state?.search?.toLowerCase()) !== -1
          ) {
            tmp.push(item);
          }
        }
      }
    }
    for (var item2 of global.clientsInactive) {
      // Code change by Differenz (23-Feb-2026)
      if (item2?.data?.uid !== "" && list?.indexOf(item?.id) !== -1) {
        tmp2.push(item2);
        if (this.state.search === "") {
          tmp.push(item2);
        } else if (
          this.state.search !== "" &&
          item2.data.name
            .toLowerCase()
            .indexOf(this?.state?.search?.toLowerCase()) !== -1
        ) {
          tmp.push(item2);
        }
      }
    }
    for (var item3 of global.userStaff) {
      if (list2.indexOf(item3?.id) !== -1) {
        if (
          item3.data.role === "manager" ||
          item3.data.role === "trainer" ||
          item3.data.role === "admin" ||
          item3.data.role === "cs"
        ) {
          tmp3.push(item3);
        }
      }
    }
    for (var item4 of global.chatsGroup) {
      isImportant = false;
      var trainerTime4 = item4.data.timeTrainer !== undefined && !isNaN(parseInt(item4.data.timeTrainer)) ? parseInt(item4.data.timeTrainer) : 0;
      if (trainerTime4 > 9999999999) trainerTime4 = Math.floor(trainerTime4 / 1000);
      if (item4.data.dateTrainer && Moment(item4.data.dateTrainer, "DD/MM/YYYY HH:mm:ss").isValid()) {
        var dtTrain4 = parseInt(Moment(item4.data.dateTrainer, "DD/MM/YYYY HH:mm:ss").format("X"));
        if (!isNaN(dtTrain4) && dtTrain4 > 0) {
          trainerTime4 = Math.max(trainerTime4, dtTrain4);
        }
      }
      if (global.uidUser !== global.uid && item4.staff) {
        for (var st4 of item4.staff) {
          if (st4.id === global.uidUser && st4.data) {
            if (st4.data.timestamp && !isNaN(parseInt(st4.data.timestamp))) {
              var stTs4 = parseInt(st4.data.timestamp);
              if (stTs4 > 9999999999) stTs4 = Math.floor(stTs4 / 1000);
              trainerTime4 = Math.max(trainerTime4, stTs4);
            } else if (st4.data.date && Moment(st4.data.date, "DD/MM/YYYY HH:mm:ss").isValid()) {
              var stDt = parseInt(Moment(st4.data.date, "DD/MM/YYYY HH:mm:ss").format("X"));
              if (!isNaN(stDt) && stDt > 0) {
                trainerTime4 = Math.max(trainerTime4, stDt);
              }
            }
          }
        }
      }
      for (var msg4 of item4.messages) {
        msg4.date = Moment(msg4.data.date, "DD/MM/YYYY HH:mm:ss");
        if (msg4.data.timestamp !== undefined) {
          var msgTs4 = parseInt(msg4.data.timestamp);
          if (msgTs4 > 9999999999) msgTs4 = Math.floor(msgTs4 / 1000);
          msg4.date = Moment(msgTs4, "X");
        }
        var msgTime4 = parseInt(msg4.date.format("X"));
        if (
          msgTime4 > trainerTime4 &&
          msg4.data.sender !== global.uidUser
        ) {
          isImportant = true;
        }
      }
      if (this.state.search === "") {
        if (isImportant) {
          tmp41.push(item4);
        } else {
          tmp4.push(item4);
        }
      } else if (
        this.state.search !== "" &&
        item4.data.name
          .toLowerCase()
          .indexOf(this?.state?.search?.toLowerCase()) !== -1
      ) {
        if (isImportant) {
          tmp41.push(item4);
        } else {
          tmp4.push(item4);
        }
      }
    }

    var messages = [];
    if (this.state.mode === "chat" || this.state.mode === "edit") {
      for (var chat of global.chats) {
        if (chat.id === this.state.chat) {
          messages = chat.messages;
        }
      }
      for (var chat2 of global.chatsGroup) {
        if (chat2.id === this.state.chat) {
          messages = chat2.messages;
        }
      }
    }
    for (var msg of messages) {
      msg.date = Moment(msg.data.date, "DD/MM/YYYY HH:mm:ss");
      if (msg.data.timestamp !== undefined) {
        msg.date = Moment(msg.data.timestamp, "X");
      }
    }
    this.setState(
      {
        clients: tmp,
        chats: global.chats,
        chatsGroup: tmp4,
        chatsUnread: tmp41,
        chatsUnreadSingle: tmp5,
        messages: messages,
        available: tmp2,
        staff: tmp3,
        savailable: tmp3,
      },
      () => {
        if (this.state.mode === "chat" && this.state.chat !== "") {
          this.scrollToBottom();
        }
      },
    );
  }

  toggleChat() {
    var tmp = this.state.show;
    if (!tmp) {
      this.setState({
        show: true,
        mode: "list",
        hidden: "",
      });
    } else {
      if (this.state.chat !== "" && this.state.mode === "chat") {
        this.closeChat();
      }
      this.setState({
        hidden: "hidden",
        show: false,
      });
    }
  }

  getInfo(item) {
    var hasDate = false;
    var label = "";
    for (var chat of this.state.chats) {
      if (chat.data.client === item) {
        var date = Moment("01/01/1900", "DD/MM/YYYY").format("X");
        for (var msg of chat.messages) {
          var mdate = Moment(msg.data.date, "DD/MM/YYYY HH:mm:ss").format("X");
          var ddate = Moment(msg.data.date, "DD/MM/YYYY HH:mm:ss");
          if (msg.data.timestamp !== undefined) {
            mdate = Moment(msg.data.timestamp, "X").format("X");
            ddate = Moment(msg.data.timestamp, "X");
          }
          if (mdate > date) {
            hasDate = true;
            date = mdate;
            label = this.getDate(ddate);
          }
        }
      }
    }
    if (hasDate) {
      return (
        <p>
          Last message
          <br />
          {label}
        </p>
      );
    } else {
      return (
        <p>
          Click to start
          <br />a conversation
        </p>
      );
    }
  }

  getInfoGroup(item) {
    var hasDate = false;
    var label = "";
    var date = Moment("01/01/1900", "DD/MM/YYYY").format("X");
    for (var msg of item.messages) {
      var mdate = Moment(msg.data.date, "DD/MM/YYYY HH:mm:ss").format("X");
      var ddate = Moment(msg.data.date, "DD/MM/YYYY HH:mm:ss");
      if (msg.data.timestamp !== undefined) {
        mdate = Moment(msg.data.timestamp, "X").format("X");
        ddate = Moment(msg.data.timestamp, "X");
      }
      if (mdate > date) {
        hasDate = true;
        date = mdate;
        label = this.getDate(ddate);
      }
    }
    if (hasDate) {
      return (
        <p>
          {item.clients.length + item.staff.length + 1} members
          <br />
          Last: {label}
        </p>
      );
    } else {
      return (
        <p>
          {item.clients.length + item.staff.length + 1} members
          <br />
          Start a conversation
        </p>
      );
    }
  }

  getBullet(item) {
    var show = false;
    for (var chat of this.state.chats) {
      if (chat.id === item.data.chat) {
        var trainerTime = chat.data.timeTrainer !== undefined && !isNaN(parseInt(chat.data.timeTrainer)) ? parseInt(chat.data.timeTrainer) : 0;
        if (trainerTime > 9999999999) trainerTime = Math.floor(trainerTime / 1000);
        if (chat.data.dateTrainer && Moment(chat.data.dateTrainer, "DD/MM/YYYY HH:mm:ss").isValid()) {
          var dtTrain = parseInt(Moment(chat.data.dateTrainer, "DD/MM/YYYY HH:mm:ss").format("X"));
          if (!isNaN(dtTrain) && dtTrain > 0) {
            trainerTime = Math.max(trainerTime, dtTrain);
          }
        }
        for (var msg of chat.messages) {
          var dt = Moment(msg.data.date, "DD/MM/YYYY HH:mm:ss").format("X");
          if (msg.data.timestamp !== undefined) {
            var tmpTs = parseInt(msg.data.timestamp);
            if (tmpTs > 9999999999) tmpTs = Math.floor(tmpTs / 1000);
            dt = tmpTs;
          }
          if (
            parseInt(dt) > trainerTime &&
            msg.data.sender !== global.uidUser
          ) {
            show = true;
          }
        }
      }
    }
    for (var chat2 of this.state.chatsGroup) {
      if (chat2.id === item.id) {
        var trainerTime2 = chat2.data.timeTrainer !== undefined && !isNaN(parseInt(chat2.data.timeTrainer)) ? parseInt(chat2.data.timeTrainer) : 0;
        if (trainerTime2 > 9999999999) trainerTime2 = Math.floor(trainerTime2 / 1000);
        if (chat2.data.dateTrainer && Moment(chat2.data.dateTrainer, "DD/MM/YYYY HH:mm:ss").isValid()) {
          var dtTrain2 = parseInt(Moment(chat2.data.dateTrainer, "DD/MM/YYYY HH:mm:ss").format("X"));
          if (!isNaN(dtTrain2) && dtTrain2 > 0) {
            trainerTime2 = Math.max(trainerTime2, dtTrain2);
          }
        }
        if (global.uidUser !== global.uid && chat2.staff) {
          for (var st of chat2.staff) {
            if (st.id === global.uidUser && st.data) {
              if (st.data.timestamp && !isNaN(parseInt(st.data.timestamp))) {
                var stTs = parseInt(st.data.timestamp);
                if (stTs > 9999999999) stTs = Math.floor(stTs / 1000);
                trainerTime2 = Math.max(trainerTime2, stTs);
              } else if (st.data.date && Moment(st.data.date, "DD/MM/YYYY HH:mm:ss").isValid()) {
                var stDt = parseInt(Moment(st.data.date, "DD/MM/YYYY HH:mm:ss").format("X"));
                if (!isNaN(stDt) && stDt > 0) {
                  trainerTime2 = Math.max(trainerTime2, stDt);
                }
              }
            }
          }
        }
        for (var msg2 of chat2.messages) {
          var dt2 = Moment(msg2.data.date, "DD/MM/YYYY HH:mm:ss").format("X");
          if (msg2.data.timestamp !== undefined) {
            var tmpTs2 = parseInt(msg2.data.timestamp);
            if (tmpTs2 > 9999999999) tmpTs2 = Math.floor(tmpTs2 / 1000);
            dt2 = tmpTs2;
          }
          if (
            parseInt(dt2) > trainerTime2 &&
            msg2.data.sender !== global.uidUser
          ) {
            show = true;
          }
        }
      }
    }
    if (show) {
      return <div className="dot"></div>;
    }
  }

  getDate(date) {
    var label = Moment(date).locale(lang.language).format("llll");
    var dt = Moment(date, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY");
    var tdy = Moment().format("DD/MM/YYYY");
    var yst = Moment().add(-1, "days").format("DD/MM/YYYY");
    if (dt === tdy) {
      label =
        lang.t("messaging:label.today") +
        " " +
        Moment(date, "DD/MM/YYYY HH:mm:ss").locale(lang.language).format("LT");
    }
    if (dt === yst) {
      label =
        lang.t("messaging:label.yesterday") +
        " " +
        Moment(date, "DD/MM/YYYY HH:mm:ss").locale(lang.language).format("LT");
    }
    return label;
  }

  getImage(name) {
    var tmp = this.state.images;
    var found = false;
    var label = "";
    for (var image of this.state.images) {
      if (image.indexOf(name) !== -1) {
        found = true;
        label = image;
      }
    }
    if (!found) {
      var img = "/images/messaging/" + this.state.chat + "/" + name + ".jpg";
      Firebase.storage()
        .ref()
        .child(img)
        .getDownloadURL()
        .then((url) => {
          tmp.push(url);
          this.setState({ images: tmp });
        })
        .catch((error) => {});
    }

    return label;
  }

  getClient(id) {
    var client = null;
    for (var item of global.clients) {
      if (item.data.uid === id) {
        client = item;
      }
    }
    return client;
  }

  getClientName(id) {
    var label = lang.t("common:label.deletedclient");
    for (var item of global.clients) {
      if (item.data.uid === id) {
        label = item.data.name;
      }
    }
    for (var item2 of global.userStaff) {
      if (item2.id === id) {
        label = item2.data.name;
      }
      if (item2.id === global.uidUser) {
        label = lang.t("common:label.yourself");
      }
    }
    return label;
  }

  // Interactive stuff ------------------------------------------------------------

  filterClients(event) {
    this.setState(
      {
        search: event.target.value,
      },
      () => {
        this.configureData();
      },
    );
  }

  selectChat(item) {
    var id = global.uidUser + item.data.uid;
    var messages = [];
    for (var chat of this.state.chats) {
      if (chat.id === id) {
        messages = chat.messages;
        chat.data.timeTrainer = parseInt(Moment().format("X"));
        chat.data.dateTrainer = Moment().format("DD/MM/YYYY HH:mm:ss");
      }
    }
    for (var msg of messages) {
      if (
        Moment(msg.data.date, "DD/MM/YYYY HH:mm:ss") < Moment().add(-30, "days")
      ) {
        if (msg.data.image !== undefined && msg.data.image !== "") {
          Firebase.storage()
            .ref("images/" + chat.id + "/" + msg.data.image + ".jpg")
            .delete();
        }
        Firebase.database()
          .ref("/messaging/" + id + "/messages/" + msg.id)
          .remove()
          .then(() => {
            this.setMessages();
          })
          .catch((error) => {});
      }
    }
    var tmp = this.state.chatsUnreadSingle;
    if (tmp.length > 0) {
      for (var i = tmp.length - 1; i > -1; i--) {
        if (tmp[i] === id) {
          tmp.splice(i, 1);
        }
      }
    }
    this.setState(
      {
        mode: "chat",
        name: item.data.name,
        chat: id,
        messages: messages,
        text: "",
        client: item.data.uid,
        chatsUnreadSingle: tmp,
        images: [],
      },
      () => {
        Firebase.database()
          .ref("/messaging/" + id)
          .update({
            timeTrainer: parseInt(Moment().format("X")),
            dateTrainer: Moment().format("DD/MM/YYYY HH:mm:ss"),
          });
        setTimeout(() => {
          this.scrollToBottom();
        }, 50);
      },
    );
  }

  selectChatGroup(id) {
    var messages = [];
    var nowX = parseInt(Moment().format("X"));
    var nowDt = Moment().format("DD/MM/YYYY HH:mm:ss");
    for (var chat of this.state.chatsGroup) {
      if (chat.id === id) {
        messages = chat.messages;
        chat.data.timeTrainer = nowX;
        chat.data.dateTrainer = nowDt;
      }
    }
    for (var chat2 of this.state.chatsUnread) {
      if (chat2.id === id) {
        messages = chat2.messages;
        chat2.data.timeTrainer = nowX;
        chat2.data.dateTrainer = nowDt;
      }
    }
    for (var gchat of global.chatsGroup) {
      if (gchat.id === id) {
        gchat.data.timeTrainer = nowX;
        gchat.data.dateTrainer = nowDt;
      }
    }
    for (var msg of messages) {
      if (
        Moment(msg.data.date, "DD/MM/YYYY HH:mm:ss") < Moment().add(-30, "days")
      ) {
        if (msg.data.image !== undefined && msg.data.image !== "") {
          Firebase.storage()
            .ref("images/" + id + "/" + msg.data.image + ".jpg")
            .delete();
        }
        Firebase.database()
          .ref(
            "/messagingGroup/" +
              global.uid +
              "/" +
              id +
              "/messages/" +
              msg.id,
          )
          .remove()
          .then(() => {
            this.setMessages();
          })
          .catch((error) => {});
      }
    }
    var tmpUnread = this.state.chatsUnread;
    if (tmpUnread.length > 0) {
      for (var i = tmpUnread.length - 1; i > -1; i--) {
        if (tmpUnread[i].id === id) {
          tmpUnread.splice(i, 1);
        }
      }
    }
    this.setState(
      {
        mode: "chat",
        name: lang.t("messaging:label.groupchat"),
        chat: id,
        messages: messages,
        client: "group",
        text: "",
        chatsUnread: tmpUnread,
        images: [],
      },
      () => {
        Firebase.database()
          .ref("/messagingGroup/" + global.uid + "/" + id)
          .update({
            timeTrainer: parseInt(Moment().format("X")),
            dateTrainer: Moment().format("DD/MM/YYYY HH:mm:ss"),
          });
        if (global.uidUser !== global.uid) {
          Firebase.database()
            .ref(
              "/messagingGroup/" +
                global.uid +
                "/" +
                id +
                "/staff/" +
                global.uidUser,
            )
            .update({
              date: Moment().format("DD/MM/YYYY HH:mm:ss"),
              timestamp: parseInt(Moment().format("X")),
            });
        }
        setTimeout(() => {
          this.scrollToBottom();
        }, 50);
      },
    );
  }

  scrollToBottom() {
    const scrollHeight = this.divElement.scrollHeight;
    const height = this.divElement.clientHeight;
    const maxScrollTop = scrollHeight - height;
    this.divElement.scrollTop = maxScrollTop > 0 ? maxScrollTop : 0;
  }

  setMessages() {
    var messages = [];
    for (var chat of this.state.chats) {
      if (chat.id === this.state.chat) {
        messages = chat.messages;
      }
    }
    for (var chat2 of this.state.chatsGroup) {
      if (chat2.id === this.state.chat) {
        messages = chat2.messages;
      }
    }
    for (var chat3 of this.state.chatsUnread) {
      if (chat3.id === this.state.chat) {
        messages = chat3.messages;
      }
    }
    this.setState({
      messages: messages,
    });
  }

  closeChat() {
    this.setState({
      mode: "list",
      chat: "",
    });
    if (this.state.client !== "group") {
      if (HelperBusiness.getRoleIncl("")) {
        Firebase.database()
          .ref("/messaging/" + this.state.chat)
          .update({
            dateTrainer: Moment().format("DD/MM/YYYY HH:mm:ss"),
            timeTrainer: parseInt(Moment().format("X")),
          });
      } else {
        Firebase.database()
          .ref("/messaging/" + this.state.chat)
          .update({
            dateTrainer: Moment().format("DD/MM/YYYY HH:mm:ss"),
            timeTrainer: parseInt(Moment().format("X")),
          });
      }

      var hasChat = false;
      for (var item of this.state.chats) {
        if (item.id === this.state.chat) {
          hasChat = true;
        }
      }
      if (!hasChat) {
        Firebase.database()
          .ref("/messaging/" + this.state.chat)
          .update({
            dateTrainer: Moment().format("DD/MM/YYYY HH:mm:ss"),
            dateClient: "01/01/1900 00:00:00",
            timeTrainer: parseInt(Moment().format("X")),
            nameTrainer: global.userName,
            nameClient: this.state.name,
            trainer: global.uidUser,
            client: this.state.client,
            id: this.state.chat,
          });
      } else {
        this.updateItem();
      }
    } else {
      Firebase.database()
        .ref("/messagingGroup/" + global.uid + "/" + this.state.chat)
        .update({
          dateTrainer: Moment().format("DD/MM/YYYY HH:mm:ss"),
          timeTrainer: parseInt(Moment().format("X")),
        });
      if (global.uidUser !== global.uid) {
        Firebase.database()
          .ref(
            "/messagingGroup/" +
              global.uid +
              "/" +
              this.state.chat +
              "/staff/" +
              global.uidUser,
          )
          .update({
            date: Moment().format("DD/MM/YYYY HH:mm:ss"),
            timestamp: parseInt(Moment().format("X")),
          });
      }
      this.updateGroupItem();
    }
  }

  onChange(event) {
    //this.setState({text: event.target.value});
    this.setState({ text: event });
  }

  sendMessage(schedule) {
    var date = Moment().format("DD/MM/YYYY HH:mm:ss");
    var ts = parseInt(Moment().format("X"));
    if (schedule) {
      date = Moment(
        this.state.date + " " + this.state.min + ":" + this.state.sec + ":00",
        "YYYY-MM-DD HH:mm:ss",
      ).format("DD/MM/YYYY HH:mm:ss");
      ts = parseInt(
        Moment(
          this.state.date + " " + this.state.min + ":" + this.state.sec + ":00",
          "YYYY-MM-DD HH:mm:ss",
        ).format("X"),
      );
      this.hideModalSchedule();
    }
    if (this.state.text !== "" && this.state.client !== "group") {
      var text = this.state.text;
      var hasChat = false;
      for (var item of this.state.chats) {
        if (item.id === this.state.chat) {
          hasChat = true;
        }
      }
      if (!hasChat) {
        Firebase.database()
          .ref("/messaging/" + this.state.chat)
          .update({
            dateTrainer: Moment().format("DD/MM/YYYY HH:mm:ss"),
            timeTrainer: parseInt(Moment().format("X")),
            dateClient: "01/01/1900 00:00:00",
            nameTrainer: global.userName,
            nameClient: this.state.name,
            trainer: global.uidUser,
            client: this.state.client,
            id: this.state.chat,
          });
      }
      var obj = Firebase.database()
        .ref("/messaging/" + this.state.chat + "/messages")
        .push();
      obj.set({
        date: date,
        timestamp: ts,
        image: "",
        sender: global.uidUser,
        text: text,
      });
      var name = "";
      if (HelperBusiness.getRole("trainer,admin,cs")) {
        name = " (" + global.userBusiness + ")";
      }
      var token = "";
      for (var client1 of global.clients) {
        if (
          client1.data.uid === this.state.client &&
          client1.data.pushToken !== undefined &&
          client1.data.pushToken !== ""
        ) {
          token = client1.data.pushToken;
        }
      }
      if (!schedule) {
        Connector.sendPushNotification(
          token,
          global.userName + name,
          text,
          "chat",
          this.state.chat,
        );
      } else {
        // Create push entry
        Firebase.database()
          .ref("/schedule/" + obj.key)
          .update({
            title: global.userName + name,
            desc: text,
            iid: this.state.chat,
            type: "chat",
            uid: global.uid,
            timestamp: parseInt(ts),
            tokens: [token],
            message: "push",
          });
      }

      this.setState({
        text: "",
      });
    } else if (this.state.text !== "" && this.state.client === "group") {
      var text2 = this.state.text;
      var name = global.userName;
      if (HelperBusiness.getRole("manager,trainer,admin,cs")) {
        name += " (" + global.userBusiness + ")";
      }
      var name2 = "";
      if (HelperBusiness.getRole("trainer,admin,cs")) {
        name2 = " (" + global.userBusiness + ")";
      }
      var obj2 = Firebase.database()
        .ref(
          "/messagingGroup/" + global.uid + "/" + this.state.chat + "/messages",
        )
        .push();
      obj2.set({
        //date: Moment().format('DD/MM/YYYY HH:mm:ss'),
        //timestamp: parseInt(Moment().format('X')),
        date: date,
        timestamp: ts,
        image: "",
        sender: global.uidUser,
        text: text2,
        name: global.userName + name2,
      });

      var sent = [];
      var cname = "Group chat";
      for (var cht of this.state.chatsGroup) {
        if (cht.id === this.state.chat) {
          cname = cht.data.name;
          for (var client of cht.clients) {
            for (var item2 of global.clients) {
              if (
                client.id === item2.data.uid &&
                sent.indexOf(item2?.data?.pushToken) === -1 &&
                item2.data.pushToken !== undefined &&
                item2.data.pushToken !== ""
              ) {
                sent.push(item2.data.pushToken);
              }
            }
          }
        }
      }
      if (sent.length > 0 && !schedule) {
        Connector.sendPushNotification(
          "",
          global.userName + " @ " + cname,
          text2,
          "chat",
          this.state.chat,
          sent,
        );
      }
      if (schedule && sent.length > 0) {
        // Create push entry
        Firebase.database()
          .ref("/schedule/" + obj2.key)
          .update({
            title: global.userName + " @ " + cname,
            desc: text2,
            iid: this.state.chat,
            type: "chat",
            uid: global.uid,
            timestamp: parseInt(ts),
            tokens: sent,
            message: "push",
          });
      }

      this.setState({
        text: "",
      });
    }
  }

  updateItem() {
    var nowX = parseInt(Moment().format("X"));
    var nowDt = Moment().format("DD/MM/YYYY HH:mm:ss");
    var tmp = this.state.chats;
    for (var item of tmp) {
      if (item.id === this.state.chat) {
        item.data.dateTrainer = nowDt;
        item.data.timeTrainer = nowX;
      }
    }
    for (var gitem of global.chats) {
      if (gitem.id === this.state.chat) {
        gitem.data.dateTrainer = nowDt;
        gitem.data.timeTrainer = nowX;
      }
    }
    this.setState({
      chats: tmp,
    });
  }

  updateGroupItem() {
    var nowX = parseInt(Moment().format("X"));
    var nowDt = Moment().format("DD/MM/YYYY HH:mm:ss");
    var tmp = this.state.chatsGroup;
    for (var item of tmp) {
      if (item.id === this.state.chat) {
        item.data.dateTrainer = nowDt;
        item.data.timeTrainer = nowX;
      }
    }
    for (var gitem of global.chatsGroup) {
      if (gitem.id === this.state.chat) {
        gitem.data.dateTrainer = nowDt;
        gitem.data.timeTrainer = nowX;
      }
    }
    var tmpUnread = this.state.chatsUnread;
    if (tmpUnread.length > 0) {
      for (var i = tmpUnread.length - 1; i > -1; i--) {
        if (tmpUnread[i].id === this.state.chat) {
          tmpUnread.splice(i, 1);
        }
      }
    }
    this.setState({
      chatsGroup: tmp,
      chatsUnread: tmpUnread,
    });
  }

  saveNote(msg) {
    var sender = msg.data.name;
    var id = "undefined";
    if (msg.data.sender === global.uidUser) {
      sender = lang.t("common:label.you");
    }
    for (var item of global.clients) {
      if (this.state.chat === global.uid + item.data.uid) {
        id = item.id;
      }
    }
    if (id !== "undefined") {
      Firebase.database()
        .ref("/clients/" + global.uid + "/" + id + "/history/" + msg.id)
        .update({
          date: Moment(msg.data.date, "DD/MM/YYYY HH:mm:aa").format(
            "DD/MM/YYYY HH:mm",
          ),
          title: lang.t("messaging:label.chatmessage"),
          desc: sender + ": " + msg.data.text,
        });
      EventEmitter.dispatch(
        "showMessage",
        lang.t("messaging:message.messagesaved"),
      );
    }
  }

  // Schedule modal ------------------------------------------------------------

  showModalSchedule(id, txt, dte) {
    var text = this.state.text;
    var date = Moment().format("DD/MM/YYYY HH:mm:ss");
    if (id !== "") {
      text = txt;
      date = Moment(dte, "DD/MM/YYYY HH:mm:ss").format("DD/MM/YYYY HH:mm:ss");
    }
    this.setState({
      showModalSchedule: true,
      mid: id,
      text: text,
      date: Moment(date, "DD/MM/YYYY HH:mm:ss").format("YYYY-MM-DD"),
      min: Moment(date, "DD/MM/YYYY HH:mm:ss").format("HH"),
      sec: Moment(date, "DD/MM/YYYY HH:mm:ss").format("mm"),
    });
    setTimeout(() => {
      const height = this.divElement.clientHeight;
      this.setState({
        hiddenSchedule: "",
        margin: -height / 2,
      });
    }, 100);
  }

  hideModalSchedule() {
    const height = this.divElement.clientHeight;
    this.setState({
      hiddenSchedule: "hidden",
      margin: -height / 2 + 100,
    });
    setTimeout(() => {
      this.setState({
        showModalSchedule: false,
      });
    }, 500);
    if (this.state.mid !== "") {
      setTimeout(() => {
        this.setState({
          text: "",
        });
      }, 510);
    }
  }

  renderScheduleDelete() {
    if (this.state.mid !== "") {
      return (
        <div className="pt-20">
          <button
            className="btn tertiary width-12"
            onClick={() => this.deleteSchedule()}
          >
            {lang.t("messaging:button.deletemessage")}
          </button>
        </div>
      );
    }
  }

  renderModalSchedule() {
    if (this.state.showModalSchedule) {
      return (
        <div className={"overlay " + this.state.hiddenSchedule}>
          <div
            className="box auto"
            ref={(divElement) => {
              this.divElement = divElement;
            }}
            style={{ marginTop: this.state.margin }}
          >
            <h2 className="mb-20 lft">
              {this.state.mid === ""
                ? lang.t("modals:form.data9.title2")
                : lang.t("modals:form.data9.title3")}
            </h2>
            <button
              className="btn tertiary small close rgt"
              onClick={() => this.hideModalSchedule()}
            >
              {lang.t("common:button.close")}
            </button>
            <Textarea
              label={"Message"}
              value={this.state.text}
              onChange={(event) => this.onChange(event)}
            />
            <div className="col-6">
              <InputDate
                label={lang.t("modals:form.data9.date")}
                value={this.state.date}
                format="YYYY-MM-DD"
                min={Moment().format("YYYY-MM-DD")}
                onChange={(event) =>
                  this.setState({ date: Moment(event).format("YYYY-MM-DD") })
                }
              />
            </div>
            <div className="col-3">
              <Select
                label={lang.t("modals:form.data9.hour")}
                value={this.state.min}
                values={[
                  { name: "00", value: "00" },
                  { name: "01", value: "01" },
                  { name: "02", value: "02" },
                  { name: "03", value: "03" },
                  { name: "04", value: "04" },
                  { name: "05", value: "05" },
                  { name: "06", value: "06" },
                  { name: "07", value: "07" },
                  { name: "08", value: "08" },
                  { name: "09", value: "09" },
                  { name: "10", value: "10" },
                  { name: "11", value: "11" },
                  { name: "12", value: "12" },
                  { name: "13", value: "13" },
                  { name: "14", value: "14" },
                  { name: "15", value: "15" },
                  { name: "16", value: "16" },
                  { name: "17", value: "17" },
                  { name: "18", value: "18" },
                  { name: "19", value: "19" },
                  { name: "20", value: "20" },
                  { name: "21", value: "21" },
                  { name: "22", value: "22" },
                  { name: "23", value: "23" },
                ]}
                onChange={(event) => this.setState({ min: event })}
              />
            </div>
            <div className="col-3">
              <Select
                label={lang.t("modals:form.data9.min")}
                value={this.state.sec}
                values={[
                  { name: "00", value: "00" },
                  { name: "15", value: "15" },
                  { name: "30", value: "30" },
                  { name: "45", value: "45" },
                ]}
                onChange={(event) => this.setState({ sec: event })}
              />
            </div>
            <div className="clear sv-10"></div>
            <button
              className="btn primary"
              onClick={() =>
                this.state.mid === ""
                  ? this.sendMessage(true)
                  : this.updateSchedule()
              }
            >
              {this.state.mid === ""
                ? lang.t("modals:form.data9.title2")
                : lang.t("common:button.savechanges")}
            </button>
            {this.renderScheduleDelete()}
          </div>
        </div>
      );
    }
  }

  updateSchedule() {
    if (this.state.text !== "") {
      this.hideModalSchedule();
      var date = Moment(
        this.state.date + " " + this.state.min + ":" + this.state.sec + ":00",
        "YYYY-MM-DD HH:mm:ss",
      ).format("DD/MM/YYYY HH:mm:ss");
      var ts = parseInt(
        Moment(
          this.state.date + " " + this.state.min + ":" + this.state.sec + ":00",
          "YYYY-MM-DD HH:mm:ss",
        ).format("X"),
      );
      if (this.state.client === "group") {
        Firebase.database()
          .ref(
            "/messagingGroup/" +
              global.uid +
              "/" +
              this.state.chat +
              "/messages/" +
              this.state.mid,
          )
          .update({
            date: date,
            timestamp: ts,
            text: this.state.text,
          });
      } else {
        Firebase.database()
          .ref("/messaging/" + this.state.chat + "/messages/" + this.state.mid)
          .update({
            date: date,
            timestamp: ts,
            text: this.state.text,
          });
      }
      Firebase.database()
        .ref("/schedule/" + this.state.mid)
        .update({
          desc: this.state.text,
          timestamp: parseInt(ts),
        });
      EventEmitter.dispatch(
        "showMessage",
        lang.t("messaging:message.messageupdated"),
      );
    }
  }

  deleteSchedule() {
    this.hideModalSchedule();
    Firebase.database()
      .ref(
        "/messagingGroup/" +
          global.uid +
          "/" +
          this.state.chat +
          "/messages/" +
          this.state.mid,
      )
      .remove();
    Firebase.database()
      .ref("/messaging/" + this.state.chat + "/messages/" + this.state.mid)
      .remove();
    EventEmitter.dispatch(
      "showMessage",
      lang.t("messaging:message.messagedeleted"),
    );
    Firebase.database()
      .ref("/schedule/" + this.state.mid)
      .remove();
  }

  // Group chat forms ------------------------------------------------------------

  showEditNew() {
    var tmp = [];
    var tmp2 = [];
    for (var item of global.clients) {
      if (item.data.uid !== "") {
        tmp.push(item);
      }
    }
    for (var item2 of global.userStaff) {
      if (
        item2.data.role === "manager" ||
        item2.data.role === "trainer" ||
        item2.data.role === "admin" ||
        item2.data.role === "cs"
      ) {
        tmp2.push(item2);
      }
    }
    this.setState({
      mode: "edit",
      value: "",
      selected: [],
      selectedList: [],
      selectedInit: [],
      available: tmp,
      sselected: [],
      sselectedInit: [],
      savailable: tmp2,
    });
  }

  editChat() {
    var name = "";
    var tmp = [];
    var tmpl = [];
    var tmp1 = [];
    var tmp2 = [];
    var tmps = [];
    var tmps1 = [];
    var tmps2 = [];
    for (var item of this.state.chatsGroup) {
      if (item.id === this.state.chat) {
        name = item.data.name;
        for (var client of item.clients) {
          tmp.push(client.id);
          tmp1.push(client.id);
        }
        for (var staff of item.staff) {
          tmps.push(staff.id);
          tmps1.push(staff.id);
        }
      }
    }
    for (var item2 of global.clients) {
      if (item2.data.uid !== "" && tmp?.indexOf(item2?.data?.uid) === -1) {
        tmp2.push(item2);
      }
      if (tmp?.indexOf(item2?.data?.uid) !== -1) {
        tmpl.push(item2.id);
      }
    }
    for (var item3 of global.userStaff) {
      if (
        (item3.data.role === "manager" ||
          item3.data.role === "trainer" ||
          item3.data.role === "admin" ||
          item3.data.role === "cs") &&
        tmps.indexOf(item3?.id) === -1
      ) {
        tmps2.push(item3);
      }
    }
    this.setState({
      mode: "edit",
      value: name,
      selected: tmp,
      selectedList: tmpl,
      selectedInit: tmp1,
      available: tmp2,
      sselected: tmps,
      sselectedInit: tmps1,
      savailable: tmps2,
    });
  }

  cancelEdit() {
    var mode = "list";
    if (this.state.chat !== "") {
      mode = "chat";
    }
    this.resetEdit();
    this.setState({
      mode: mode,
    });
  }

  resetEdit() {
    var tmp = [];
    var tmp2 = [];
    for (var item of global.clients) {
      if (item.data.uid !== "") {
        tmp.push(item);
      }
    }
    for (var item2 of global.userStaff) {
      if (item.id !== "") {
        tmp.push(item2);
      }
    }
    this.setState({
      value: "",
      selected: [],
      selectedList: [],
      available: tmp,
      sselected: [],
      savailable: tmp2,
      error: ["", ""],
    });
  }

  updateName(event) {
    this.setState({
      value: event.target.value,
    });
  }

  updateClients(list) {
    var tmp = [];
    for (var item of global.clients) {
      if (list.indexOf(item?.id) !== -1) {
        tmp.push(item?.data?.uid);
      }
    }
    this.setState({
      selectedList: list,
      selected: tmp,
    });
    this.hideModals();
  }

  removeClient(id) {
    var tmp = this.state.selected;
    var tmp2 = [];
    for (var i = 0; i < this.state.selected.length; i++) {
      if (this.state.selected[i] === id) {
        tmp.splice(i, 1);
      }
    }
    for (var item of global.clients) {
      if (this.state.selected.indexOf(item?.data?.uid) === -1) {
        tmp2.push(item);
      }
    }
    this.setState({
      selected: tmp,
      available: tmp2,
    });
  }

  addStaff(id) {
    var tmp = this.state.sselected;
    var tmp2 = [];
    tmp.push(id);
    for (var item of this.state.staff) {
      if (
        item.data.role === "manager" ||
        item.data.role === "trainer" ||
        item.data.role === "admin" ||
        item.data.role === "cs"
      ) {
        tmp2.push(item);
      }
    }
    this.setState({
      sselected: tmp,
      savailable: tmp2,
    });
  }

  removeStaff(id) {
    var tmp = this.state.sselected;
    var tmp2 = [];
    for (var i = 0; i < this.state.sselected.length; i++) {
      if (this.state.sselected[i] === id) {
        tmp.splice(i, 1);
      }
    }
    for (var item of this.state.staff) {
      if (tmp.indexOf(item?.id) === -1) {
        tmp2.push(item);
      }
    }
    this.setState({
      sselected: tmp,
      savailable: tmp2,
    });
  }

  checkCreateChat() {
    var tmp = ["", ""];
    if (this.state.value !== "" && this.state.selected.length > 0) {
      if (this.state.chat === "") {
        this.createChat();
      } else {
        this.updateChat();
      }
    } else {
      if (this.state.value === "") {
        tmp[0] = lang.t("messaging:form.selectaname");
      }
      if (this.state.selected.length === 0) {
        tmp[1] = lang.t("messaging:form.selectclient");
      }
    }
    this.setState({
      error: tmp,
    });
  }

  createChat() {
    global.chatCreate = true;
    var obj = Firebase.database()
      .ref("/messagingGroup/" + global.uid)
      .push();
    obj
      .set({
        dateTrainer: Moment().format("DD/MM/YYYY HH:mm:ss"),
        timeTrainer: parseInt(Moment().format("X")),
        name: this.state.value,
        nameTrainer: global.userName,
        trainer: global.uidUser,
        clients: [],
      })
      .then(() => {
        for (var item of this.state.selected) {
          var name = "";
          for (var client of global.clients) {
            if (client.data.uid === item) {
              name = client.data.name;
            }
          }
          Firebase.database()
            .ref(
              "/messagingGroup/" +
                global.uid +
                "/" +
                obj.key +
                "/clients/" +
                item,
            )
            .update({
              name: name,
              date: Moment().format("DD/MM/YYYY HH:mm:ss"),
              timestamp: parseInt(Moment().format("X")),
            });
        }
        // Staff members
        for (var item2 of this.state.sselected) {
          var name2 = "";
          for (var staff of global.userStaff) {
            if (staff.id === item2) {
              name2 = staff.data.name + " (" + global.userBusiness + ")";
            }
          }
          Firebase.database()
            .ref(
              "/messagingGroup/" +
                global.uidUser +
                "/" +
                obj.key +
                "/staff/" +
                item2,
            )
            .update({
              name: name2,
              date: Moment().format("DD/MM/YYYY HH:mm:ss"),
              timestamp: parseInt(Moment().format("X")),
            });
        }
        setTimeout(() => {
          global.chatCreate = false;
          this.resetEdit();
        }, 2000);
        EventEmitter.dispatch("showMessage", "Chat successfully created");
        this.setState({
          mode: "list",
        });
      })
      .catch((error) => {
        EventEmitter.dispatch("showMessageError", error.message);
      });
  }

  updateChat() {
    global.chatCreate = true;
    Firebase.database()
      .ref("/messagingGroup/" + global.uid + "/" + this.state.chat)
      .update({
        name: this.state.value,
      })
      .then(() => {
        var add = [];
        var rem = [];
        var sadd = [];
        var srem = [];
        for (var item of this.state.selected) {
          if (this.state.selectedInit.indexOf(item) === -1) {
            add.push(item);
          }
        }
        for (var item2 of this.state.selectedInit) {
          if (this.state.selected.indexOf(item2) === -1) {
            rem.push(item2);
          }
        }
        for (var ri of rem) {
          Firebase.database()
            .ref(
              "/messagingGroup/" +
                global.uid +
                "/" +
                this.state.chat +
                "/clients/" +
                ri,
            )
            .remove();
        }
        for (var ai of add) {
          var name = "";
          for (var client of global.clients) {
            if (client.data.uid === ai) {
              name = client.data.name;
            }
          }
          Firebase.database()
            .ref(
              "/messagingGroup/" +
                global.uid +
                "/" +
                this.state.chat +
                "/clients/" +
                ai,
            )
            .update({
              name: name,
              date: Moment().format("DD/MM/YYYY HH:mm:ss"),
              timestamp: parseInt(Moment().format("X")),
            });
        }
        // Staff
        for (var items of this.state.sselected) {
          if (this.state.sselectedInit.indexOf(items) === -1) {
            sadd.push(items);
          }
        }
        for (var items2 of this.state.sselectedInit) {
          if (this.state.sselected.indexOf(items2) === -1) {
            srem.push(items2);
          }
        }
        for (var sri of srem) {
          Firebase.database()
            .ref(
              "/messagingGroup/" +
                global.uid +
                "/" +
                this.state.chat +
                "/staff/" +
                sri,
            )
            .remove();
        }
        for (var sai of sadd) {
          var sname = "";
          for (var staff of global.userStaff) {
            if (staff.id === sai) {
              sname = staff.data.name + " (" + global.userBusiness + ")";
            }
          }
          Firebase.database()
            .ref(
              "/messagingGroup/" +
                global.uid +
                "/" +
                this.state.chat +
                "/staff/" +
                sai,
            )
            .update({
              name: sname,
              date: Moment().format("DD/MM/YYYY HH:mm:ss"),
              timestamp: parseInt(Moment().format("X")),
            });
        }
        setTimeout(() => {
          global.chatCreate = false;
          this.resetEdit();
        }, 2000);
        EventEmitter.dispatch(
          "showMessage",
          lang.t("messaging:message.chatclosed"),
        );
        //this.selectChat(this.state.chat)
        this.setState({
          mode: "list",
        });
      })
      .catch((error) => {
        EventEmitter.dispatch("showMessageError", error.message);
      });
  }

  deleteChat() {
    Firebase.database()
      .ref("/messagingGroup/" + global.uid + "/" + this.state.chat)
      .remove();
    EventEmitter.dispatch("showMessage", "Chat successfully closed");
    this.setState({
      mode: "list",
      chat: "",
    });
  }

  hideModals() {
    this.setState({
      showModalClients: false,
    });
  }

  saveMessage() {}

  // Display stuff ------------------------------------------------------------

  renderMessageContent(item) {
    if (item.data.image === "") {
      return <div className="message-text">{item.data.text}</div>;
    } else {
      return (
        <div className="message-text">
          <img src={this.getImage(item.data.image)} alt="Chat" />
        </div>
      );
    }
  }

  renderMessageUser(item) {
    var label = "";
    if (item.data.name !== undefined && item.data.sender !== global.uidUser) {
      label = item.data.name + " - ";
    }
    return label;
  }

  getChatInter() {
    var label = "";
    if (this.state.client !== "group") {
      label = "interactive";
    }
    return label;
  }

  renderChatItem(item) {
    var date = Moment(item.data.date, "DD/MM/YYYY HH:mm:ss");
    if (item.data.timestamp !== undefined) {
      date = Moment(item.data.timestamp, "X");
    }
    if (date < Moment()) {
      return (
        <div
          className={
            item.data.sender === global.uidUser
              ? "chat-message user " + this.getChatInter()
              : "chat-message " + this.getChatInter()
          }
          key={item.id}
          onClick={() => this.saveNote(item)}
        >
          <p className="date">
            {this.renderMessageUser(item)}
            {date.locale(lang.language).format("lll")}
            <span>{lang.t("messaging:button.savetonotes")}</span>
          </p>
          {this.renderMessageContent(item)}
          <div className="clear"></div>
        </div>
      );
    } else {
      return (
        <div
          className="chat-message user interactive scheduled"
          key={item.id}
          onClick={() =>
            this.showModalSchedule(item.id, item.data.text, item.data.date)
          }
          title={lang.t("common:button.edit")}
        >
          <p className="date">
            {this.renderMessageUser(item)}
            {date.locale(lang.language).format("lll")}{" "}
            <div className="pill primary" style={{ display: "inline-block" }}>
              {lang.t("messaging:label.scheduled")}
            </div>
          </p>
          {this.renderMessageContent(item)}
          <div className="clear"></div>
        </div>
      );
    }
  }

  renderMessages() {
    if (this.state.messages.length === 0) {
      return (
        <div
          className="chat-messages"
          ref={(divElement) => {
            this.divElement = divElement;
          }}
        >
          <ListEmpty id="chat" type="simple" />
        </div>
      );
    } else {
      var list = this.state.messages;
      list.sort(
        (a, b) =>
          Moment(a.data.timestamp, "DD/MM/YYYY HH:mm:ss") -
          Moment(b.data.timestamp, "DD/MM/YYYY HH:mm:ss"),
      );
      return (
        <div
          className="chat-messages"
          ref={(divElement) => {
            this.divElement = divElement;
          }}
        >
          {list.map((item) => this.renderChatItem(item))}
        </div>
      );
    }
  }

  renderEdit() {
    if (this.state.client === "group") {
      return (
        <button
          className="btn tertiary small rgt edit"
          style={{ marginRight: 15 }}
          onClick={() => this.editChat()}
        >
          {lang.t("common:button.edit")}
        </button>
      );
    }
  }

  renderChat() {
    return (
      <div className="chat-base">
        <div className="chat-header">
          <h4 className="lft">{this.state.name}</h4>
          <button
            className="btn tertiary small rgt close"
            onClick={() => this.closeChat()}
          >
            {lang.t("common:button.close")}
          </button>
          {this.renderEdit()}
        </div>
        {this.renderMessages()}
        <div className="chat-control">
          <textarea
            placeholder="Type something"
            value={this.state.text}
            onChange={(event) => this.onChange(event.target.value)}
          ></textarea>
          <div className="col-6 pt-10">
            <button
              className={this.state.text === "" ? "none" : "btn primary"}
              onClick={() => this.sendMessage(false)}
            >
              {lang.t("messaging:button.send")}
            </button>
          </div>
          <div className="col-4 pt-20">
            <button
              className={
                this.state.text === "" ? "none" : "btn tertiary small width-12"
              }
              onClick={() => this.showModalSchedule("", "", "")}
            >
              {lang.t("messaging:button.schedule")}
            </button>
          </div>
        </div>
      </div>
    );
  }

  renderListUnread() {
    var list = this.state.chatsUnread;
    list.sort((a, b) => a.data.name.localeCompare(b.data.name));
    return (
      <div>
        {list.map((item, index) => (
          <div
            className="list bare"
            key={item.id}
            onClick={() => this.selectChatGroup(item.id)}
          >
            <div className="icon primary">
              <div className="inner group"></div>
            </div>
            <div className="main">
              <h4>
                <span className="lft">{item.data.name}</span>
                <div className="dot"></div>
              </h4>
              <div className="clear"></div>
              {this.getInfoGroup(item)}
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderListUnreadClients() {
    var list = [];
    var addedChatIds = [];
    for (var client of global.clients) {
      var id = global.uid + client.id;
      for (var item of this.state.chats) {
        if (item.data.client === client.data.uid) {
          id = item.id;
        }
      }
      if (this.state.chatsUnreadSingle.indexOf(id) !== -1) {
        addedChatIds.push(id);
        list.push({
          id: client.id,
          data: {
            name: client.data.name,
            chat: id,
            uid: client.data.uid,
            image: client.data.image,
            avatar: client.data.avatar,
          },
        });
      }
    }
    for (var unreadChatId of this.state.chatsUnreadSingle) {
      if (addedChatIds.indexOf(unreadChatId) === -1) {
        var unreadChat = null;
        for (var c of this.state.chats) {
          if (c.id === unreadChatId) {
            unreadChat = c;
            break;
          }
        }
        if (unreadChat) {
          var matchedClient = null;
          var uClientUid = unreadChat.data ? unreadChat.data.client : "";
          var uClientName =
            unreadChat.data && unreadChat.data.nameClient
              ? unreadChat.data.nameClient.toLowerCase()
              : "";

          if (global.clients) {
            for (var cl of global.clients) {
              if (
                cl.data &&
                (cl.data.uid === uClientUid ||
                  (uClientName !== "" &&
                    cl.data.name &&
                    cl.data.name.toLowerCase() === uClientName))
              ) {
                matchedClient = cl;
                break;
              }
            }
          }
          if (!matchedClient && global.clientsInactive) {
            for (var clIn of global.clientsInactive) {
              if (
                clIn.data &&
                (clIn.data.uid === uClientUid ||
                  (uClientName !== "" &&
                    clIn.data.name &&
                    clIn.data.name.toLowerCase() === uClientName))
              ) {
                matchedClient = clIn;
                break;
              }
            }
          }

          addedChatIds.push(unreadChatId);
          list.push({
            id: matchedClient ? matchedClient.id : unreadChat.id,
            data: {
              name:
                (matchedClient && matchedClient.data && matchedClient.data.name) ||
                (unreadChat.data && unreadChat.data.nameClient) ||
                "Client",
              chat: unreadChat.id,
              uid: unreadChat.data ? unreadChat.data.client : "",
              image:
                matchedClient && matchedClient.data
                  ? matchedClient.data.image
                  : "",
              avatar:
                matchedClient && matchedClient.data
                  ? matchedClient.data.avatar
                  : "",
            },
          });
        }
      }
    }
    list.sort((a, b) => a.data.name.localeCompare(b.data.name));
    return (
      <div>
        {list.map((item, index) => (
          <div
            className="list bare"
            key={item.id}
            onClick={() => this.selectChat(item)}
          >
            {HelperClients.getImage(item)}
            <div className="main">
              <h4>
                <span className="lft">{item.data.name}</span>
                <div className="dot"></div>
              </h4>
              <div className="clear"></div>
              {this.getInfo(item.data.uid)}
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderList() {
    var list = [];
    for (var client of this.state.clients) {
      var id = global.uid + client.id;
      for (var item of this.state.chats) {
        if (
          item.data.client === client.data.uid ||
          (client.data.name &&
            item.data.nameClient &&
            item.data.nameClient.toLowerCase() ===
              client.data.name.toLowerCase())
        ) {
          id = item.id;
        }
      }
      list.push({
        id: client.id,
        data: {
          name: client.data.name,
          chat: id,
          uid: client.data.uid,
          image: client.data.image,
          avatar: client.data.avatar,
        },
      });
    }
    list.sort((a, b) => a.data.name.localeCompare(b.data.name));
    return (
      <div>
        {list.map((item, index) => (
          <div
            className="list bare"
            key={item.id}
            onClick={() => this.selectChat(item)}
          >
            {HelperClients.getImage(item)}
            <div className="main">
              <h4>
                <span className="lft">{item.data.name}</span>
                {this.getBullet(item)}
              </h4>
              <div className="clear"></div>
              {this.getInfo(item.data.uid)}
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderListGroup() {
    var list = this.state.chatsGroup;
    list.sort((a, b) => a.data.name.localeCompare(b.data.name));
    return (
      <div>
        {list.map((item, index) => (
          <div
            className="list bare"
            key={item.id}
            onClick={() => this.selectChatGroup(item.id)}
          >
            <div className="icon primary">
              <div className="inner group"></div>
            </div>
            <div className="main">
              <h4>
                <span className="lft">{item.data.name}</span>
                {this.getBullet(item)}
              </h4>
              <div className="clear"></div>
              {this.getInfoGroup(item)}
            </div>
          </div>
        ))}
      </div>
    );
  }

  renderSelected() {
    if (this.state.selected.length > 0) {
      return (
        <div className="form-item">
          <label>{lang.t("messaging:label.chatmembers")}</label>
          {this.state.selected.map((item) => (
            <div className="client small" key={item}>
              {HelperClients.getImage(this.getClient(item))}
              <p className="lft">{this.getClientName(item)}</p>
              <button
                className="btn tertiary rgt small close"
                style={{ fontSize: 10, marginTop: 7 }}
                onClick={() => this.removeClient(item)}
              >
                {lang.t("common:button.remove")}
              </button>
              <div className="clear"></div>
            </div>
          ))}
          <button
            className="btn tertiary small add width-12 mt-10"
            onClick={() => this.setState({ showModalClients: true })}
          >
            {lang.t("common:button.manage")}
          </button>
        </div>
      );
    } else {
      return (
        <div className="form-item">
          <label>{lang.t("messaging:label.chatmembers")}</label>
          <button
            className="btn tertiary add small width-12 mt-10"
            onClick={() => this.setState({ showModalClients: true })}
          >
            {lang.t("common:button.manage")}
          </button>
        </div>
      );
    }
  }

  renderSelectedStaff() {
    if (global.showHabits) {
      return (
        <div className="form-item">
          <label>{lang.t("messaging:label.chatstaffmembers")}</label>
          <div className="client small">
            <div
              className="avatar"
              style={{
                backgroundImage: "url(/img/data-client.svg)",
                backgroundSize: "contain",
              }}
            ></div>
            <p>
              {HelperBusiness.getRoleIncl("") ? "Yourself" : global.spaceOwner}
            </p>
            <div className="clear"></div>
          </div>
          {this.state.sselected.map((item) => (
            <div className="client small" key={item}>
              <div
                className="avatar"
                style={{
                  backgroundImage: "url(/img/data-client.svg)",
                  backgroundSize: "contain",
                }}
              ></div>
              <p className="lft">{this.getClientName(item)}</p>
              <button
                className="btn tertiary rgt small close"
                style={{ fontSize: 10, marginTop: 7 }}
                onClick={() => this.removeStaff(item)}
              >
                {lang.t("common:button.remove")}
              </button>
              <div className="clear"></div>
            </div>
          ))}
        </div>
      );
    }
  }

  renderError(num) {
    if (this.state.error[num] !== "") {
      return <p className="error">{this.state.error[num]}</p>;
    }
  }

  renderDelete() {
    if (this.state.chat !== "") {
      return (
        <div>
          <div className="space-20"></div>
          <button
            className="btn tertiary width-12 close"
            onClick={() => this.deleteChat()}
          >
            {lang.t("messaging:button.closethischat")}
          </button>
        </div>
      );
    }
  }

  renderAddStaff() {
    if (this.state.staff.length > 0 && global.showHabits) {
      var list = this.state.savailable;
      list.sort((a, b) => a.data.name.localeCompare(b.data.name));
      return (
        <div>
          <div className="sv-10"></div>
          <label>{lang.t("messaging:form.addstaffmembers")}</label>
          <select onChange={(event) => this.addStaff(event.target.value)}>
            <option>{lang.t("messaging:form.selectastaffmember")}</option>
            {list.map((item, index) => (
              <option key={item.id} value={item.id}>
                {item.data.name}
              </option>
            ))}
          </select>
          <div className="sv-20"></div>
        </div>
      );
    }
  }

  renderContent() {
    if (this.state.mode === "list") {
      if (
        this.state.clients.length === 0 &&
        this.state.chatsGroup.length === 0 &&
        this.state.chatsUnread.length === 0 &&
        this.state.chatsUnreadSingle.length === 0
      ) {
        return (
          <div className="chat-base">
            <div className="chat-header">
              <input
                type="text"
                value={this.state.search}
                placeholder={lang.t("messaging:label.filterbyname")}
                onChange={(event) => this.filterClients(event)}
              />
            </div>
            <div className="chat-content">
              <div className="empty small pt-60">
                <h4>{lang.t("messaging:label.nochats")}</h4>
              </div>
            </div>
          </div>
        );
      } else {
        return (
          <div className="chat-base">
            <div className="chat-header">
              <input
                type="text"
                value={this.state.search}
                placeholder={lang.t("messaging:label.filterbyname")}
                onChange={(event) => this.filterClients(event)}
              />
            </div>
            <div className="chat-content">
              {this.renderListUnread()}
              {this.renderListUnreadClients()}
              {this.renderListGroup()}
              {this.renderList()}
            </div>
          </div>
        );
      }
    } else if (this.state.mode === "edit") {
      var list = this.state.available;
      list.sort((a, b) => a.data.name.localeCompare(b.data.name));
      return (
        <div className="chat-base">
          <div className="chat-header">
            <h4 className="lft">
              {this.state.chat === ""
                ? lang.t("messaging:label.newgroupchat")
                : lang.t("messaging:label.editgroupchat")}
            </h4>
            <button
              className="btn tertiary small rgt close"
              onClick={() => this.cancelEdit()}
            >
              {lang.t("common:button.cancel")}
            </button>
          </div>
          <div className="chat-content">
            <div className="form-item">
              <label>{lang.t("messaging:form.name.label")}*</label>
              <input
                type="text"
                placeholder={lang.t("messaging:form.name.placeholder")}
                value={this.state.value}
                onChange={(val) => this.updateName(val)}
              />
              {this.renderError(0)}
            </div>
            {this.renderAddStaff()}
            {this.renderSelectedStaff()}
            {this.renderSelected()}
            {this.renderError(1)}
            <div className="sv-40"></div>
            <button
              className="btn primary mb-20"
              onClick={() => this.checkCreateChat()}
            >
              {this.state.chat === ""
                ? lang.t("messaging:button.createchat")
                : lang.t("messaging:button.updatechat")}
            </button>
            {this.renderDelete()}
          </div>
        </div>
      );
    } else {
      return this.renderChat();
    }
  }

  renderAdd() {
    if (this.state.mode === "list") {
      return (
        <button
          className="btn tertiary add small rgt"
          onClick={() => this.showEditNew()}
        >
          {lang.t("messaging:button.newgroupchat")}
        </button>
      );
    }
  }

  renderBar() {
    return (
      <div className={"chat-container " + this.state.hidden}>
        <h3 className="mb-10 lft">{lang.t("header:title.messaging")}</h3>
        {this.renderAdd()}
        <div className="clear"></div>
        {this.renderContent()}
      </div>
    );
  }

  renderMainBullet() {
    var show = false;
    for (var item of this.state.chats) {
      var trainerTime = item.data.timeTrainer !== undefined && !isNaN(parseInt(item.data.timeTrainer)) ? parseInt(item.data.timeTrainer) : 0;
      if (trainerTime > 9999999999) trainerTime = Math.floor(trainerTime / 1000);
      if (item.data.dateTrainer && Moment(item.data.dateTrainer, "DD/MM/YYYY HH:mm:ss").isValid()) {
        var dtTrain = parseInt(Moment(item.data.dateTrainer, "DD/MM/YYYY HH:mm:ss").format("X"));
        if (!isNaN(dtTrain) && dtTrain > 0) {
          trainerTime = Math.max(trainerTime, dtTrain);
        }
      }
      for (var msg of item.messages) {
        var dt = Moment(msg.data.date, "DD/MM/YYYY HH:mm:ss").format("X");
        if (msg.data.timestamp !== undefined) {
          var tmpTs = parseInt(msg.data.timestamp);
          if (tmpTs > 9999999999) tmpTs = Math.floor(tmpTs / 1000);
          dt = tmpTs;
        }
        if (
          parseInt(dt) > trainerTime &&
          msg.data.sender !== global.uidUser
        ) {
          show = true;
        }
      }
    }
    for (var item2 of this.state.chatsGroup) {
      var trainerTime2 = item2.data.timeTrainer !== undefined && !isNaN(parseInt(item2.data.timeTrainer)) ? parseInt(item2.data.timeTrainer) : 0;
      if (trainerTime2 > 9999999999) trainerTime2 = Math.floor(trainerTime2 / 1000);
      if (item2.data.dateTrainer && Moment(item2.data.dateTrainer, "DD/MM/YYYY HH:mm:ss").isValid()) {
        var dtTrain2 = parseInt(Moment(item2.data.dateTrainer, "DD/MM/YYYY HH:mm:ss").format("X"));
        if (!isNaN(dtTrain2) && dtTrain2 > 0) {
          trainerTime2 = Math.max(trainerTime2, dtTrain2);
        }
      }
      if (global.uidUser !== global.uid && item2.staff) {
        for (var st of item2.staff) {
          if (st.id === global.uidUser && st.data) {
            if (st.data.timestamp && !isNaN(parseInt(st.data.timestamp))) {
              var stTs = parseInt(st.data.timestamp);
              if (stTs > 9999999999) stTs = Math.floor(stTs / 1000);
              trainerTime2 = Math.max(trainerTime2, stTs);
            } else if (st.data.date && Moment(st.data.date, "DD/MM/YYYY HH:mm:ss").isValid()) {
              var stDt = parseInt(Moment(st.data.date, "DD/MM/YYYY HH:mm:ss").format("X"));
              if (!isNaN(stDt) && stDt > 0) {
                trainerTime2 = Math.max(trainerTime2, stDt);
              }
            }
          }
        }
      }
      for (var msg2 of item2.messages) {
        var dt2 = Moment(msg2.data.date, "DD/MM/YYYY HH:mm:ss").format("X");
        if (msg2.data.timestamp !== undefined) {
          var tmpTs2 = parseInt(msg2.data.timestamp);
          if (tmpTs2 > 9999999999) tmpTs2 = Math.floor(tmpTs2 / 1000);
          dt2 = tmpTs2;
        }
        if (
          parseInt(dt2) > trainerTime2 &&
          msg2.data.sender !== global.uidUser
        ) {
          show = true;
        }
      }
    }
    if (this.state.chatsUnread && this.state.chatsUnread.length > 0) {
      show = true;
    }
    if (this.state.chatsUnreadSingle && this.state.chatsUnreadSingle.length > 0) {
      show = true;
    }
    if (show) {
      return <div className="dot"></div>;
    }
  }

  render() {
    if (
      HelperBusiness.getRoleIncl("trainer,admin,cs") &&
      global.maxClients !== 5
    ) {
      return (
        <div>
          {this.renderBar()}
          <div
            className={this.state.show ? "chat active" : "chat"}
            onClick={() => this.toggleChat()}
          >
            {this.renderMainBullet()}
          </div>
          {this.renderModalSchedule()}
          <ModalClients
            clients={this.state.clients}
            selected={this.state.selectedList}
            multiple={true}
            title={"Select clients"}
            button={"Confirm selection"}
            show={this.state.showModalClients}
            onHide={() => this.hideModals()}
            clickMainButton={(event) => this.updateClients(event)}
          />
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}

export default withTranslation(["common", "header", "messaging", "modals"])(
  Chat,
);
